import client from './client';

export interface EmailSettings {
  smtpHost: string | null;
  smtpPort: number;
  smtpUsername: string | null;
  smtpPasswordSet: boolean;
  fromAddress: string | null;
  fromName: string;
  useTls: boolean;
  useSsl: boolean;
  enabled: boolean;
  lastTestAt: string | null;
  lastTestSuccess: boolean | null;
  lastTestError: string | null;
}

export interface UpdateEmailSettingsRequest {
  smtpHost: string;
  smtpPort: number;
  smtpUsername: string;
  smtpPassword?: string | null;
  fromAddress: string;
  fromName: string;
  useTls: boolean;
  useSsl: boolean;
  enabled: boolean;
}

export interface NotificationPreferences {
  userId: string;
  notifyLowStock: boolean;
  notifySupplyLowStock: boolean;
  notifyTransfer: boolean;
  notifyDailySalesSummary: boolean;
  notifyNewSale: boolean;
  notifyUserCreated: boolean;
  additionalRecipients: string | null;
}

export interface TestEmailResult {
  success: boolean;
  message: string;
}

export const emailApi = {
  getSettings: async (): Promise<EmailSettings> => {
    const res = await client.get('/email/settings');
    return res.data;
  },

  updateSettings: async (data: UpdateEmailSettingsRequest): Promise<EmailSettings> => {
    const res = await client.put('/email/settings', data);
    return res.data;
  },

  testConnection: async (toAddress: string): Promise<TestEmailResult> => {
    const res = await client.post('/email/settings/test', { toAddress });
    return res.data;
  },

  getNotificationPreferences: async (): Promise<NotificationPreferences> => {
    const res = await client.get('/email/notifications/preferences');
    return res.data;
  },

  updateNotificationPreferences: async (
    data: Partial<NotificationPreferences>
  ): Promise<NotificationPreferences> => {
    const res = await client.put('/email/notifications/preferences', data);
    return res.data;
  },
};
